import { apiErrorToToast, forceFileDownload } from "@/lib/utils";
import { downloadQuizExcelRequest } from "@/requests/questionnaries/download-quiz-excel.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const useDownloadQuizExcelMutation = () => {
  return useMutation({
    mutationFn: downloadQuizExcelRequest,
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
    onSuccess: (response) => {
      let fileName = "";

      const url = window.URL.createObjectURL(new Blob([response.data]));

      const contentDisposition = response.headers["content-disposition"];

      if (contentDisposition) {
        const match = contentDisposition?.match(/filename="(.+?)"/);
        fileName = match ? match[1] : null;
      }

      forceFileDownload(url, fileName || "report.xlsx");
    },
  });
};
